<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">{{title}}</h4>
      </div>

      <div class="cell shrink">
        <a href="javascript:;" @click="onExportClick()" title="Eksporter CSV" class="button action small glyph glyph-only">
          <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-spreadsheet"></use></svg>
        </a>

        <a href="javascript:;" class="button primary" v-if="submitStatus === 'submittable'" @click="onReloadClick()">Reload</a>
        <a href="javascript:;" class="button primary loading" v-else-if="submitStatus === 'loading'">Reload <span class="loader-spinner"></span></a>
        <a href="javascript:;" class="button primary" disabled v-else>Reload</a>

        <a v-if="submitStatus === 'processing'" class="button primary transparent" style="color: #bbb; cursor: not-allowed;">Gå tilbake</a>
        <router-link v-else :to="{ name: 'ReportsList' }" class="button primary transparent" >Gå tilbake</router-link>
      </div>
    </div>

    <div class="content-container flex-row">
      <router-view v-on:onSubmitStatusChange="onSubmitStatusChange"></router-view>
    </div>
  </div>
</template>

<script>
import bus from '@/plugins/event-bus'

export default {
  name: 'ObjectsPayingStorage',
  data () {
    return {
      submitStatus: null
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Lagerleieliste'
    }
  },
  methods: {
    onSubmitStatusChange: function (status) {
      this.submitStatus = status
    },
    onReloadClick: function () {
      bus.$emit('reload-kataloglist')
    },
    onExportClick: function () {
      bus.$emit('export-kataloglist')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/ObjectsPayingStorage.vue